import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useTaskAssigneesQuery } from "API";

import useFilterParam from "./useFilterParam";

const TaskAssignee: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("claimedBy");

  const { data = [], isSuccess, isError } = useTaskAssigneesQuery();
  const [selected, setSelected] = useFilterParam("assignee", data, {
    defaultToFirst: false,
    ready: isSuccess || isError,
  });

  const selectedLabel = data.find((o) => o.value === selected)?.label ?? title;

  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={selectedLabel}
      onChange={setSelected}
      selected={!!selected}
      disabled={!isSuccess}
      value={selected ?? ""}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default TaskAssignee;
